import { mediaQuery } from 'modules/utils';
import styled from 'styled-components';
import { Pagination } from '../pagination';
import { theme } from '../theme';

export const TableScrollWrapper = styled.div`
  width: 100%;
  overflow: auto;
`;

export const StyledTable = styled.table`
  display: flex;
  flex-direction: column;
  width: 100%;

  tr {
    padding: 1rem;
    margin: 0 0 1rem 0;
  }

  th,
  td {
    height: 2.188rem;
  }

  td {
    font-size: var(--main-font-size);
    margin: 0.2rem 0;
  }

  ${mediaQuery('md')} {
    display: table;

    tr {
      padding: 0;
      margin: 0;
    }

    th {
      padding: 0 0.4rem;
      height: 3.75rem;
    }

    td {
      padding: 0 0.4rem;
      margin: 0;
      height: 3.75rem;
    }
  }
`;

export const StyledPagination = styled(Pagination)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0 1rem 0;

  ${mediaQuery('md')} {
    justify-content: flex-end;
    margin: 2.625rem 0;
  }
`;
